<template>
    <div id="Consolenew_report" :class="IsShow?'unvisibility':'visibility'" >
        <span class="title-text">
            <span class="left">
                楼层数：共
                <p>{{TitleData.Floor}}</p>层
            </span>
        </span>
        <span class="title-text">
            <span class="left">
                设备数：共
                <p>{{TitleData.DeviceNum}}</p>个
            </span>
        </span>
        <div id="myChart" class="Pie-chart">
            <span>媒体信息</span>
            <ve-pie ref="chartve" :data="chartData" :settings="chartSettings" :extend="extend" legend-position="right"></ve-pie>
        </div>
    </div>
</template>
<script>
export default {
    name: "consolenew_report",
    props: {
        SiteId: {
            type: Number,
            default: 1
        },
        IsShow:{
            type: Boolean,
            default:false
        }
    },
    data: function() {
        return {
            chartSettings: {
                radius: 90,
                offsetY: 110,
                label: {
                    show: true,
                    formatter:"{b}:{c}",
                    normal:{
                        show:true,
                        position:'inner',
                        formatter:"{b}:{c}台"
                    }
                }
            },
            resizefun: null,
            searchform: {
                siteid: ""
            },
            TitleData: {
                Site_Name: "爱国路(地铁站)",
                Floor: 2,
                LightBoxNum: 3,
                DeviceNum: 5
            },
            extend: {
                legend: {
                    type: "scroll", //设置超出部分滚动
                    orient: "vertical", //设置竖向排列
                    show: true, //是否显示，默认开启
                    right: 30, //设置位置
                    top: 60,
                    textStyle: {
                        //文字样式
                        color: "#fff"
                    }
                }
            },
            chartData: {
                columns: ["状态", "台数"],
                rows: [
                    { 状态: "使用中", 台数: 65 },
                    { 状态: "未使用", 台数: 20 },
                    { 状态: "维修中", 台数: 10 },
                    { 状态: "已损坏", 台数: 5 }
                ]
            }
        };
    },
    watch: {
        SiteId: function(newSiteId, oldSiteId) {
            this.initData();
        }
    },
    mounted() {
        //实现自适应
        this.resizefun = () => {
            this.$nextTick(() => {
                //console.log(this.getHeight);
                this.screenWidth = document.body.clientWidth;
                this.screenHeight = document.body.clientHeight;
                //console.log(this.screenWidth,this.screenHeight)
                if (this.screenHeight <= "910" && this.screenHeight > "850") {
                    this.chartSettings.radius = 80;
                    this.chartSettings.offsetY = 105;
                } else if (this.screenHeight <= "850" && this.screenHeight > "800") {
                    this.chartSettings.radius = 70;
                    this.chartSettings.offsetY = 95;
                    this.extend.legend.top = 25;
                } else if (this.screenHeight <= "800" && this.screenHeight > "765") {
                    this.chartSettings.radius = 65;
                    this.chartSettings.offsetY = 85;
                    this.extend.legend.top = 20;
                } else if (this.screenHeight <= "765") {
                    this.chartSettings.radius = 60;
                    this.chartSettings.offsetY = 75;
                    this.extend.legend.top = 20;
                } else {
                    this.chartSettings.radius = 90;
                    this.chartSettings.offsetY = 115;
                    this.extend.legend.top = 60;
                }
                //  this.$refs['chartve'].echarts.setOption({
                //    radius:30
                //  });

                //this.chartSettings.offset=80;
                this.$refs["chartve"].resize();
            });
        };
        window.addEventListener("resize", this.resizefun);
    },
    //移除事件监听，避免内存泄漏
    beforeDestroy() {
        window.removeEventListener("resize", this.resizefun);
        this.resizefun = null;
    },
    methods: {
        initData() {
            var Vuethis = this;
            this.$hrraxios
                .get(this.$api.site.statistics + this.SiteId)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.TitleData.Floor = data.Data.Floor;
                        Vuethis.TitleData.LightBoxNum = data.Data.LightBoxNum;
                        Vuethis.TitleData.DeviceNum = data.Data.DeviceNum;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
            this.$hrraxios
                .get(this.$api.site.report + this.SiteId)
                .then(function(response) {
                    var data = response.data;
                    if (data.Success == true) {
                        Vuethis.chartData = data.Data;
                    } else {
                        Vuethis.$message.error(data.Prompt);
                    }
                })
                .catch(function(error) {
                    console.log(error);
                });
        },
        initParamsData() {

        }
    },
    created() {
        //实现自适应
        this.screenWidth = document.body.clientWidth;
        this.screenHeight = document.body.clientHeight;
        if (this.screenHeight <= "910" && this.screenHeight > "850") {
            this.chartSettings.radius = 80;
            this.chartSettings.offsetY = 105;
        } else if (this.screenHeight <= "850" && this.screenHeight > "800") {
            this.chartSettings.radius = 70;
            this.chartSettings.offsetY = 95;
            this.extend.legend.top = 25;
        } else if (this.screenHeight <= "800" && this.screenHeight > "765") {
            this.chartSettings.radius = 65;
            this.chartSettings.offsetY = 85;
            this.extend.legend.top = 20;
        } else if (this.screenHeight <= "765") {
            this.chartSettings.radius = 60;
           this.chartSettings.offsetY = 75;
            this.extend.legend.top = 20;
        } else {
           this.chartSettings.radius = 90;
           this.chartSettings.offsetY = 115;
           this.extend.legend.top = 60;
        }
        this.initData();
        this.initParamsData();
    }
};
</script>
<style>
#Consolenew_report {
    position: relative;
    background: url("../../assets/Report_bg.png");
    background-size: 100% 100%;
    width: 98.5%;
    height: 35%;
    margin-top: 20px;
}
.title-text:first-child{
    margin-left: 6%;
}
.title-text {
    width: 26%;
    height: 10%;
    margin-left: 2%;
    margin-top: 2.5vh;
}

.title-text span {
    width: 100%;
    height: 100%;
    font-size: 1vmax;
    font-weight: bold;
    color: #fffeff;
    letter-spacing: 0.05em;
}

.title-text p {
    display: inline-block;
    font-size: 1vmax;
    color: #4dfafe;
}

.title-text .left {
    margin-left: 1%;
}

.title-text .center {
    margin-left: 34%;
}

.title-text .right {
    margin-left: 68%;
}

.Pie-chart {
    position: absolute;
    width: 100%;
    height: 75%;
}

.Pie-chart span {
    position: absolute;
    font-size: 3.2vh;
    margin: 5% 11%;
    width: 5%;
    height: 83%;
    color: #fff;
}
</style>